import * as React from "react"

import Container from "../container/container"

import * as styles from "./steps.module.scss"
import arrow from "../../assets/testimonials/slider-arrow-next.svg"

const HomeSteps = props => {
  const data = props.data.Steps
  return (
    <div className={styles.steps}>
      <Container>
        <h2>{props.data.StepsHeading}</h2>
        <div className={styles.steps__wrap}>
          {data.map((step, key) => (
            <div className={styles.steps__step__wrap}>
              <div
                className={styles.steps__step}
                key={key}
                style={{
                  backgroundImage: `url('${step.BackgroundImage.publicURL}')`,
                }}
              >
                {/* <img src={step.Image.publicURL} alt={step.Text} /> */}
                <div className={styles.steps__step__text}>
                  <p>{step.Text}</p>
                </div>
              </div>
              {key < data.length - 1 && (
                <img
                  src={arrow}
                  className={styles.steps__step__arrow}
                  alt="Arrow right"
                />
              )}
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default HomeSteps
